import { Link } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ServicesSection from './components/ServicesSection';
import CasesSlider from './components/CasesSlider';
import ProcessSection from './components/ProcessSection';
import TestimonialsSection from './components/TestimonialsSection';
import TechSection from './components/TechSection';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <StatsSection />
      <ServicesSection />
      <CasesSlider />

      {/* Video Showcase Section */}
      <section className="py-32 bg-[#080808] relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="text-center mb-14">
            <p className="text-[#00d4ff] text-xs uppercase tracking-[3px] font-semibold mb-4">AI w akcji</p>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight mb-4">
              Jak wdrażamy AI<br />
              <span className="text-white/40">krok po kroku</span>
            </h2>
            <p className="text-white/40 text-base max-w-xl mx-auto">
              Od analizy potrzeb, przez konfigurację, aż po uruchomienie — każde wdrożenie jest dopracowane w detalach.
            </p>
          </div>

          {/* Video grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
            {/* Main video */}
            <div className="relative rounded-3xl overflow-hidden group cursor-pointer" style={{ height: '420px' }}>
              <video
                autoPlay
                muted
                loop
                playsInline
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                poster="https://public.readdy.ai/ai/img_res/8b422de44ba61f06db108d55ca5bc281.jpg"
              >
                <source src="https://assets.mixkit.co/videos/preview/mixkit-hands-of-a-man-typing-on-a-laptop-keyboard-1149-large.mp4" type="video/mp4" />
              </video>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 flex items-center justify-center">
                  <i className="ri-play-fill text-white text-2xl ml-1" />
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <span className="text-[#00d4ff] text-xs font-bold uppercase tracking-widest mb-2 block">Wdrożenie AI</span>
                <h3 className="text-2xl font-black text-white">Od analizy do uruchomienia</h3>
              </div>
            </div>

            {/* Right column */}
            <div className="flex flex-col gap-6">
              <div className="relative rounded-3xl overflow-hidden group cursor-pointer flex-1" style={{ minHeight: '200px' }}>
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  poster="https://readdy.ai/api/search-image?query=drone%20aerial%20photography%20cinematic%20dark%20sky%20city%20lights%20professional%20equipment%20flying%20technology%20premium%20production&width=900&height=400&seq=vid2&orientation=landscape"
                >
                  <source src="https://assets.mixkit.co/videos/preview/mixkit-aerial-view-of-city-traffic-at-night-11-large.mp4" type="video/mp4" />
                </video>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="text-[#00ff88] text-xs font-bold uppercase tracking-widest mb-1 block">Produkcja mediów & SEO</span>
                  <h3 className="text-xl font-black text-white">Dron, Foto & Wizytówki Google</h3>
                </div>
              </div>

              <div className="relative rounded-3xl overflow-hidden group cursor-pointer flex-1" style={{ minHeight: '200px' }}>
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  poster="https://readdy.ai/api/search-image?query=SEO%20analytics%20data%20visualization%20glowing%20charts%20dark%20background%20digital%20marketing%20performance%20metrics%20professional%20technology&width=900&height=400&seq=vid3&orientation=landscape"
                >
                  <source src="https://assets.mixkit.co/videos/preview/mixkit-digital-animation-of-futuristic-devices-99786-large.mp4" type="video/mp4" />
                </video>
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="text-[#ff6b9d] text-xs font-bold uppercase tracking-widest mb-1 block">Agenci AI</span>
                  <h3 className="text-xl font-black text-white">Obsługa klienta 24/7 bez ludzi</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ProcessSection />
      <TechSection />
      <TestimonialsSection />
      <FaqSection />

      {/* Marquee / Ticker */}
      <section className="py-10 bg-[#060606] overflow-hidden border-y border-white/5">
        <div className="flex gap-0 animate-marquee whitespace-nowrap">
          {Array.from({ length: 3 }).map((_, gi) => (
            <div key={gi} className="flex items-center gap-10 pr-10">
              {[
                'Agenci AI',
                'EUDR & Compliance AI',
                'Szkolenia z AI',
                'Oprogramowanie AI',
                'Strony WWW Premium',
                'Local SEO',
                'Google Wizytówka',
                'Automatyzacja Procesów',
                'AI dla E-commerce',
                'Wirtualne Wycieczki 360°',
              ].map((item, i) => (
                <div key={`${gi}-${i}`} className="flex items-center gap-4 flex-shrink-0">
                  <span className="text-white/20 text-sm font-medium tracking-wide">{item}</span>
                  <span className="w-1.5 h-1.5 rounded-full bg-[#00d4ff]/40 flex-shrink-0" />
                </div>
              ))}
            </div>
          ))}
        </div>
        <style>{`
          @keyframes marquee {
            0% { transform: translateX(0); }
            100% { transform: translateX(-33.333%); }
          }
          .animate-marquee {
            animation: marquee 30s linear infinite;
          }
        `}</style>
      </section>

      {/* Lead Magnet */}
      <section id="lead-magnet" className="py-24 bg-[#0a0a0a] relative overflow-hidden">
        <div className="max-w-[1200px] mx-auto px-6">
          <div
            className="relative rounded-3xl overflow-hidden p-10 md:p-16"
            style={{
              background: 'linear-gradient(135deg, rgba(0,212,255,0.08) 0%, rgba(0,255,136,0.05) 50%, rgba(255,107,157,0.05) 100%)',
              border: '1px solid rgba(0,212,255,0.15)',
            }}
          >
            {/* BG decoration */}
            <div className="absolute top-0 right-0 w-96 h-96 rounded-full pointer-events-none"
              style={{ background: 'radial-gradient(circle, rgba(0,212,255,0.08) 0%, transparent 70%)', filter: 'blur(40px)' }}
            />

            <div className="relative z-10 flex flex-col lg:flex-row items-center gap-10">
              {/* Icon */}
              <div
                className="flex-shrink-0 w-24 h-24 rounded-3xl flex items-center justify-center"
                style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)' }}
              >
                <i className="ri-robot-2-line text-5xl text-[#00d4ff]" />
              </div>

              {/* Text */}
              <div className="flex-1 text-center lg:text-left">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#00d4ff]/10 border border-[#00d4ff]/20 mb-4">
                  <span className="text-[#00d4ff] text-xs font-bold uppercase tracking-widest">Bezpłatny przewodnik</span>
                </div>
                <h3 className="text-2xl md:text-3xl font-black text-white mb-3">
                  Lista kontrolna: Jak wdrożyć AI w firmie krok po kroku
                </h3>
                <p className="text-white/45 text-sm leading-relaxed">
                  18 punktów, które sprawdzamy przed każdym wdrożeniem AI. Pobierz i oceń gotowość swojej firmy.
                </p>
              </div>

              {/* CTA */}
              <div className="flex-shrink-0">
                <Link
                  to="/kontakt"
                  className="flex items-center gap-2 px-8 py-4 rounded-xl font-bold text-black text-sm whitespace-nowrap cursor-pointer hover:scale-105 transition-transform shadow-[0_0_30px_rgba(0,212,255,0.3)]"
                  style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)' }}
                >
                  <i className="ri-download-line" />
                  Pobierz bezpłatnie
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CtaSection />
      <Footer />

      {/* Sticky floating CTA */}
      <Link
        to="/kontakt"
        className="fixed bottom-8 right-8 z-50 flex items-center gap-2 px-5 py-3.5 rounded-full font-bold text-black text-sm whitespace-nowrap cursor-pointer hover:scale-110 transition-transform shadow-[0_0_30px_rgba(0,212,255,0.5)]"
        style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)' }}
      >
        <i className="ri-calendar-check-line text-lg" />
        <span className="hidden sm:inline">Umów konsultację</span>
      </Link>
    </div>
  );
}
